import { RestResource } from "./common"
import { SchemaDeSerBuilder } from "./deser"

export enum UserTeamRole {
  OWNER = "owner",
  MEMBER = "member",
}

export class UserTeam extends RestResource {
  name = ""
  users: UserTeamMember[] = []
}

export class UserTeamMember extends RestResource {
  firstName = "foo"
  lastName = "bar"
  role: `${UserTeamRole}` = UserTeamRole.MEMBER
  email = ""
  teamId = ""
  name = ""
}

export const USER_TEAM_MEMBER_DESER = new SchemaDeSerBuilder<UserTeamMember>(
  UserTeamMember
)
  .ofString("id")
  .ofString("role")
  .ofString("email")
  .ofString("teamId")
  .ofString("name")
  .toDeSer()

export const USER_TEAMS_DESER = new SchemaDeSerBuilder<UserTeam>(UserTeam)
  .ofString("id")
  .ofString("name")
  .ofArray("users", USER_TEAM_MEMBER_DESER, UserTeamMember, "user-teams-users")
  .toDeSer()
